import { MaterialType } from "../../../types/materials";
import { ImageCardBaseVariants, ImageCardVariants } from "./types";

export const defaultCardColorScheme: Record<
  ImageCardVariants,
  {
    backgroundColorClassName: string;
  }
> = {
  [ImageCardBaseVariants.Dark]: {
    backgroundColorClassName: "bg-dark",
  },
  [ImageCardBaseVariants.Default]: {
    backgroundColorClassName: "bg-primary",
  },
  [MaterialType.Glass]: {
    backgroundColorClassName: "bg-glass",
  },
  [MaterialType.Wood]: {
    backgroundColorClassName: "bg-wood",
  },
  [MaterialType.Stone]: {
    backgroundColorClassName: "bg-stone",
  },
  [MaterialType.Materia]: {
    backgroundColorClassName: "bg-materia",
  },
  [MaterialType.Metal]: {
    backgroundColorClassName: "bg-metal",
  },
};
